import { SaleForm } from '../../../pages/sales/SaleForm';
import { UserList } from '../../../fixed/users/userList';
import { ListInterpreter } from '../../../@core/components/interpreter/ListInterpreter';
import { UserForm } from '../../../fixed/users/userForm';
import { SaleList } from '../../../pages/sales/SaleList';
import { FormInterpreter } from '../../../@core/components/interpreter/FormInterpreter';
import { ContactList } from '../../../fixed/contacts/contactList';

const baseUsers = {
  title: 'Usuarios',
  endPoint: 'user',
  listOptions: {
    params: {
      extraUrl: 'find/all',
    },
    columns: UserList,
  },
  form: UserForm,
};

const baseLeads = {
  title: 'Lead',
  endPoint: 'sale',
  listOptions: {
    columns: ContactList,
    params: {
      filter: ['oportunity||$eq||1'],
    },
  },
  form: SaleForm,
};

const AdminRoutes = [
  {
    path: '/admin/sales',
    exact: true,
    component: () => <SaleList />,
    layout: 'VerticalLayout',
    meta: {
      action: 'insert',
      resource: 'sale',
    },
  },
  {
    path: '/admin/sales/:type',
    exact: true,
    component: () => <SaleList />,
    layout: 'VerticalLayout',
    meta: {
      action: 'insert',
      resource: 'sale',
    },
  },
  {
    path: '/admin/sales/:type/:id',
    component: () => <SaleForm />,
    layout: 'VerticalLayout',
    meta: {
      action: 'update',
      resource: 'sale',
    },
  },
  {
    path: '/admin/users',
    exact: true,
    component: () => <ListInterpreter {...baseUsers} />,
    layout: 'VerticalLayout',
    meta: {
      action: 'read',
      resource: 'user',
    },
  },
  {
    path: '/admin/users/:id',
    exact: true,
    component: () => <ListInterpreter {...baseUsers} />,
    layout: 'VerticalLayout',
    meta: {
      action: 'edit',
      resource: 'user',
    },
  },
  {
    path: '/admin/leads',
    exact: true,
    component: () => <ListInterpreter {...baseLeads} />,
    layout: 'VerticalLayout',
    meta: {
      action: 'read',
      resource: 'sale',
    },
  },
  {
    path: '/admin/leads/:id',
    exact: true,
    component: () => <SaleForm />,
    layout: 'VerticalLayout',
    meta: {
      action: 'read',
      resource: 'sale',
    },
  },
];

export default AdminRoutes;
